const article = {
    slug: "sacai",
    category: "BRAND BUYBACK",
    listTitle: "sacai買取",
    listDescription:
      "異素材切替、ドッキング、コラボレーションの価値まで見て査定するEnclopediaのsacai専用買取ページ。",
    seo: {
      title:
        "sacai買取｜異素材切替・コラボ・アーカイブ価値まで見て査定するEnclopedia",
      description:
        "sacaiの買取ならEnclopediaへ。異素材切替、ドッキング構造、コラボレーション、シーズン性、希少性まで見て査定します。まずはLINE事前査定から宅配買取へご案内します。",
      keyword:
        "sacai 買取,サカイ 買取,sacai 高価買取,sacai 宅配買取,sacai アーカイブ 買取,sacai コラボ 買取,sacai Nike 買取,sacai WTAPS 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/sacai",
    },
    hero: {
      label: "SACAI BUYBACK",
      number: "02 / BUYBACK",
      titleLines: [
        "sacai買取。",
        "構造の価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、sacaiをブランド名だけで一律に判断しません。\n異素材切替、ドッキング構造、シーズン背景、コラボレーション性まで確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで事前にご相談いただき、納得感のある宅配買取へつなげます。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "buyback",
        "hybrid construction",
        "collaboration value",
        "sacai",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: ["素材の切替だけでなく、", "構造の背景まで見る。"],
      image: "media/archive_fashion/buyback2.png",
      imageAlt: "sacai買取のメイン画像",
    },
    thesis: {
      text:
        "sacaiの価値は、人気だけでなく、服の構造・シーズン性・協業背景まで見て判断する。",
      keywords: ["construction", "season", "rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "sacaiの価値は、",
        "“異素材ミックス”の一言では終わらない。",
      ],
      body:
        "sacaiは、見慣れた服の構造を組み替えることで新しい輪郭を生み出してきたブランドです。\nニットと布帛、テーラードとミリタリー、スカートとプリーツなど、異なる要素を一着の中で成立させる設計に特徴があります。\nEnclopediaでは、単なる人気ブランドとしてではなく、その服が持つ構造的な価値と市場性をあわせて見ます。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: ["Enclopediaが重視する、", "3つの査定視点。"],
      items: [
        {
          number: "01",
          title: "構造とデザイン性を見る",
          text:
            "異素材切替、ドッキング、レイヤード表現など、sacaiらしさがどの程度アイテムに表れているかを確認します。",
        },
        {
          number: "02",
          title: "シーズン性と希少性を見る",
          text:
            "どの時期の作品か、流通量がどの程度か、再入手しにくいピースかを踏まえて個別に判断します。",
        },
        {
          number: "03",
          title: "コラボレーション価値を見る",
          text:
            "WTAPS、NIKEをはじめとした協業品は、通常ラインとは異なる需要や評価軸があるため、背景を見て査定します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: ["sacai全般を、", "幅広く査定します。"],
      items: [
        {
          tag: "ITEM 01",
          title: "sacai レディース",
          text:
            "ワンピース、スカート、ニット、ジャケット、コートなど、ウィメンズの主要アイテムを幅広く査定します。",
        },
        {
          tag: "ITEM 02",
          title: "sacai メンズ",
          text:
            "ブルゾン、ジャケット、パンツ、ニット、シャツなど、構造性の強いメンズアイテムも積極的に見ます。",
        },
        {
          tag: "ITEM 03",
          title: "異素材切替・ドッキング系",
          text:
            "sacaiの代表性が強い切替ニット、ドッキングアウター、レイヤードスカートは特に丁寧に査定します。",
        },
        {
          tag: "ITEM 04",
          title: "コラボレーションアイテム",
          text:
            "sacai × WTAPS、sacai × NIKEなど、需要の強い協業品は内容に応じて個別評価します。",
        },
        {
          tag: "ITEM 05",
          title: "アウター・ジャケット",
          text:
            "MA-1、トレンチ、テーラード、ミリタリー由来のアウターなど、sacaiらしい構造の出るアイテムを見ます。",
        },
        {
          tag: "ITEM 06",
          title: "ニット・スウェット",
          text:
            "異素材の接続やレイヤード表現が分かりやすいトップス類も査定対象です。",
        },
        {
          tag: "ITEM 07",
          title: "スカート・ワンピース",
          text:
            "プリーツ、布帛、異素材を組み合わせたボトムスやドレスは、sacaiらしさが評価に結びつきやすい領域です。",
        },
        {
          tag: "ITEM 08",
          title: "バッグ・小物類",
          text:
            "アイテムにより査定可能です。コレクション性や市場需要を確認して個別にご案内します。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: ["高価買取につながりやすい、", "sacaiのアイテム。"],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のようなsacaiを丁寧に見ます。",
      items: [
        {
          index: "01",
          title: "異素材切替・ドッキング構造が際立つ代表作",
          text:
            "ニット、ジャケット、スカート、ワンピースなど、sacaiの設計思想が明確に表れたアイテムは評価対象です。",
        },
        {
          index: "02",
          title: "人気シーズンの象徴的なアイテム",
          text:
            "その時期のコレクション性を強く示すルックや、継続的に需要のあるアウター類は丁寧に査定します。",
        },
        {
          index: "03",
          title: "sacai × WTAPS、sacai × NIKEなどのコラボレーション",
          text:
            "ブランド同士の文脈が重なる協業品は、市場評価が通常ラインと異なる場合があるため、個別に価値を見ます。",
        },
        {
          index: "04",
          title: "状態良好なアーカイブ・入手困難品",
          text:
            "過去作の中でも流通量が少なく、現在も需要が続いているものは、年代だけでなく希少性まで含めて判断します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“人気ブランド”としてではなく、",
        "構造を持った服として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: ["一般的な査定で、", "見落とされやすいsacaiの価値。"],
      intro:
        "Enclopediaは、単純な型番相場だけでなく、そのアイテムがsacaiの中でどのような意味を持つかも確認します。",
      items: [
        {
          index: "01",
          title: "異素材切替を“装飾”として片付けない",
          text:
            "sacaiの切替や重なりは、ブランドの本質に関わる設計です。どの程度構造性が強いかを見ます。",
        },
        {
          index: "02",
          title: "コラボ品を一括評価しない",
          text:
            "コラボレーションは、相手ブランドや発売時期、現在の需要で評価が変わります。個別に確認します。",
        },
        {
          index: "03",
          title: "着用価値と再流通価値をあわせて見る",
          text:
            "Enclopediaはレンタル事業も行うため、次に着る人へ渡る価値があるかという視点も持って査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: ["LINE事前査定から、", "宅配買取へ。"],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。宅配買取へ進む前に、おおまかな査定可否をご案内します。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: ["相談しやすく、", "進めやすいsacai買取。"],
      intro:
        "LINEで相談してから進められるため、買取成立までの不安と手間を減らせます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、無駄な発送や手間を減らせます。",
        },
        {
          title: "送料は無料",
          text: "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: ["sacai買取で、", "よくあるご質問。"],
      items: [
        {
          question: "どのsacaiアイテムを買取していますか？",
          answer:
            "ジャケット、コート、ニット、スカート、ワンピース、パンツ、コラボレーション品など幅広くご相談いただけます。",
        },
        {
          question: "sacai × WTAPSやsacai × NIKEも査定できますか？",
          answer:
            "はい。コラボレーション背景や市場需要を確認し、通常ラインとは分けて個別に評価します。",
        },
        {
          question: "古いsacaiの方が高くなりますか？",
          answer:
            "年代だけで一律には判断しません。現在の需要、シーズン性、希少性、状態を総合して査定します。",
        },
        {
          question: "異素材切替のアイテムは評価されやすいですか？",
          answer:
            "sacaiらしさが強く表れるため注目して見ます。ただし、査定額は状態・需要・アイテムごとの流通性を踏まえて判断します。",
        },
        {
          question: "LINE査定をせずに宅配買取を申し込めますか？",
          answer:
            "申込自体は可能ですが、事前にLINE査定をご利用いただくことで、査定可否や大まかな方向性を確認しやすくなります。",
        },
        {
          question: "宅配キットは必ず使う必要がありますか？",
          answer:
            "必須ではありません。宅配キットは選択制のため、ご自身で梱包いただける場合はそのまま発送いただけます。",
        },
      ],
    },
    finalCta: {
      titleLines: ["まずはLINEで、", "sacaiの価値をご相談ください。"],
      body:
        "異素材切替、コラボレーション、シーズン背景まで確認。\nEnclopediaが、次の流通へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
